module.exports = __webpack_public_path__ + "38a62e17f1f3ba11d4500b5af24b6b45.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1155
// module chunks = 0